<template>
	<div id="mainbar" :class="{ 'side-opened': sideOpened, 'side-closed': !sideOpened, 'mainbar-extended': mainbarExtended, 'mainbar-not-extended': !mainbarExtended }">
		<div id="side-hider" class="opened" @click="toggleSide">
			<IconMenu/>
			<IconChevronRight class="hover-chevron" />
		</div>
		<SearchButton id="search-button" />
		<div class="left" v-if="currentSong && isCurrentSongInUserSongs">
			<QueueController />
			<TransposeButton />
			<EditSongButton id="edit-song-button" />
			<SongPlaylistsButton id="song-playlists-button" />
			<DeleteSongButton id="delete-song-button" />
		</div>
		<AddSongButton v-if="currentSong && !isCurrentSongInUserSongs" />
		<div class="right">
			<MoreButton v-if="currentSong" />
			<UserSettingsButton />
		</div>
	</div>
</template>

<script>
	import SearchButton from "./SearchButton"
	import DeleteSongButton from "./DeleteSongButton"
	import AddSongButton from "./AddSongButton";
	import QueueController from "./QueueController";
	import UserSettingsButton from "./UserSettingsButton";
	import SongPlaylistsButton from "./SongPlaylistsButton";
	import TransposeButton from "./TransposeButton";
	import EditSongButton from "./EditSongButton";
	import { mapState } from "vuex";
	import IconMenu from "@/components/icons/IconMenu";
	import IconChevronRight from "@/components/icons/IconChevronRight";
	import MoreButton from "./MoreButton";

	export default {
		components: {
			MoreButton,
			SearchButton,
			QueueController,
			AddSongButton,
			UserSettingsButton,
			TransposeButton,
			EditSongButton,
			IconMenu,
			IconChevronRight,
			SongPlaylistsButton,
			DeleteSongButton
		},
		computed: {
			...mapState([ "currentUser", "currentSong", "songs", "sideOpened", "mainbarExtended" ]),
			isAnonymous() {
				return this.currentUser === null || this.currentUser.isAnonymous;
			},
			isCurrentSongInUserSongs() {
				return "songId" in this.currentSong && this.currentSong.songId in this.songs;
			}
		},
		methods: {
			toggleSide() {
				this.$store.commit("setSideOpened", !this.sideOpened);
			},
			orientationChanged() {
				this.$store.commit("setMainbarExtended", false);
			}
		},
		mounted() {
			window.addEventListener("orientationchange", this.orientationChanged);
		},
		destroyed() {
			window.removeEventListener("orientationchange", this.orientationChanged);
		}

	}

</script>


<style lang="scss">
	#mainbar {
		background-color: #323a40;
		width: 100vw;
		height: 50px;
		position: fixed;
		top: 0;
		top: calc(constant(safe-area-inset-top) + 0px);
		top: calc(env(safe-area-inset-top) + 0px);
		left: 0;
		z-index: 49;
		overflow-y: visible;
		overflow-x: visible;

		-webkit-transition: left 0.2s, width 0.2s;
		-moz-transition: left 0.2s, width 0.2s;
		-o-transition: left 0.2s, width 0.2s;
		transition: left 0.2s, width 0.2s;

		&.side-opened {
			left: 260px;
			width: calc(100vw - 260px);

			.hover-chevron {
				margin: 7px 0 0 12px !important;
				transform: rotate(180deg);
				transform-origin: center center;
			}

			@media only screen and (max-width: 930px) {
				#edit-song-button {
					display: none;
				}

				#song-playlists-button {
					display: none;
				}

				#delete-song-button {
					display: none;
				}

				#transpose-button {
					display: none;
				}
			}

			@media only screen and (max-width: 630px) {
				#queue-controller {
					display: none;
				}
			}

			@media only screen and (max-width: 510px) {
				#settings-button {
					display: none;
				}
			}

			@media only screen and (max-width: 452px) {
				#search-button {
					display: none;
				}
			}
		}

		&.side-closed {
			@media only screen and (max-width: 603px) {
				#more-button {
					display: block;
				}

				.left {
					position: absolute;
					top: 50px;
					left: 0;
					transform-origin: left center;
					width: 500px;
				}

				&.mainbar-not-extended {
					.left {
						display: none;
					}
				}

				&.mainbar-extended {
					height: 100px;
				}
			}

			@media only screen and (max-width: 400px) {
				.left {
					transform: scale(0.9);
				}
			}

			@media only screen and (max-width: 340px) {
				.left {
					transform: scale(0.8);
				}
			}
		}

		#more-button {
			display: none;
		}

		.left {
			//position: absolute;
			left: 50px;
			top: 0;
			height: 50px;
		}

		.right {
			float: right;

			#mango-logo {
				height: 40px;
				margin: 5px 10px 0 10px;
				float: right;
			}
		}

		button {
			font-weight: 300;
			margin: 5px 0;
			padding: 0 20px;
			border: 0;
			font-size: 1em;
			line-height: 40px;
			background-color: #356173;
			color: rgba(255, 255, 255, 0.75);
			cursor: pointer;
			margin-left: 10px;
			border-radius: 4px;
			float: left;

			@media(hover: hover) and (pointer: fine) {
				&:hover {
					background-color: #264653;
				}
			}

			&:focus {
				outline: none;
			}
		}

		#side-hider {
			background-color: rgba(244,162,97,1);
			width: 50px;
			height: 50px;
			border-bottom-right-radius: 16px;
			border-top-right-radius: 16px;
			float: left;
			cursor: pointer;

			.icon {
				padding: 8px 0 0 8px;
				height: 33px;
				position: absolute;

				transition: opacity 0.2s, visibility 0.2s;
			}

			&:hover {
				.hover-chevron {
					visibility: visible;
					opacity: 1;
				}
				.icon-menu {
					visibility: hidden;
					opacity: 0;
				}
			}

			.hover-chevron {
				width: 19px;
				margin: 1px 0 0 8px;
				visibility: hidden;
				opacity: 0;
			}
		}
	}

	#settings-button,
	#edit-song-button,
	#song-playlists-button,
	#delete-song-button,
	#transpose-button,
	#search-button,
	#queue-controller,
	#more-button {
		animation: LatencyDisplay 0.22s;
	}

	@keyframes LatencyDisplay {
		0%   { opacity: 0; }
		95%  { opacity: 0; }
		100% { opacity: 1; }
	}

</style>
